import React from 'react';
import { Icon } from '../icon/Icon.jsx';
import { Button } from '../controls/Button.jsx';

/* Full-width, above content, for conditions that make the screen below NOT
   CURRENTLY TRUE. Banners never stack — if two conditions apply, the more severe
   renders and the other becomes an attention card. */

const TONE = { loss: 'var(--loss)', live: 'var(--live)', paper: 'var(--paper)', neutral: 'var(--border-default)' };

export function Banner({ tone = 'loss', icon = 'triangle-alert', title, detail, action, onAction, dismissable = false, onDismiss, style, children }) {
  return (
    <div role="status" style={{
      display: 'flex', alignItems: 'flex-start', gap: 'var(--space-12)',
      borderLeft: '3px solid ' + (TONE[tone] || TONE.loss),
      background: 'var(--bg-surface)', padding: 'var(--space-12) var(--space-16)', width: '100%',
      boxSizing: 'border-box', ...style,
    }}>
      {icon ? <Icon name={icon} size={16} style={{ color: TONE[tone] || TONE.loss, marginTop: 3 }} /> : null}
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
        <div style={{ fontSize: 'var(--body-size)', lineHeight: 'var(--body-line)', fontWeight: 500, color: 'var(--text-primary)' }}>{title}</div>
        {detail ? <div style={{ fontSize: 'var(--caption-size)', lineHeight: 'var(--caption-line)', color: 'var(--text-secondary)' }}>{detail}</div> : null}
        {children}
      </div>
      {action ? <Button density="compact" onClick={onAction}>{action}</Button> : null}
      {dismissable ? <Button density="compact" variant="ghost" onClick={onDismiss}>Dismiss</Button> : null}
    </div>
  );
}
